var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        [
          _c("sui-container", [
            _c("div", { staticClass: "manager-header" }, [
              _c("div", { staticClass: "title" }, [
                _c("span", [_c("h2", [_vm._v("Firms")])]),
              ]),
              _c(
                "div",
                { staticClass: "search-filter" },
                [
                  _c("sui-input", {
                    attrs: {
                      placeholder: "Search firm list...",
                      icon: "search",
                      "icon-position": "left",
                    },
                    model: {
                      value: _vm.searchPhrase,
                      callback: function ($$v) {
                        _vm.searchPhrase = $$v
                      },
                      expression: "searchPhrase",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "actions" },
                [
                  _c("sui-button", {
                    attrs: {
                      basic: "",
                      size: "tiny",
                      content: "New Firm",
                      color: "blue",
                    },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.handleNewFirm.apply(null, arguments)
                      },
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
        ],
        1
      ),
      _c(
        "sui-container",
        [
          _c("FirmList", {
            attrs: { firms: _vm.firms },
            on: {
              getFirm: _vm.getFirm,
              toggleModal: _vm.toggleModal,
              showDeleteAlert: _vm.showDeleteAlert,
            },
          }),
          _c("FirmModal", {
            attrs: {
              isOpen: _vm.isOpen,
              isNew: _vm.isNew,
              firm: _vm.firm,
              "toggle-modal": _vm.toggleModal,
              "reset-is-new": _vm.resetIsNew,
            },
          }),
          _c("DeleteAlert", {
            ref: "deleteAlert",
            on: { handleDelete: _vm.deleteFirm },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }